<template>
    <section class="container px-0 pt-0 mt-3" v-if="features.length > 0">
      <div class="heading-box mb-3">
        <h2 class="h4 heading">Vollständige Ausstattung</h2>
      </div>

        <div class="mb-2" style="position: relative">

            <div class="fader d-none d-md-block" v-if="features.length > featuresBeforeFadeoutDesktop && !showAll"></div>
            <div class="fader d-block d-md-none" v-if="features.length > featuresBeforeFadeoutMobile && !showAll"></div>

            <!-- Desktop -->
            <div class="d-none d-md-block px-3">
                <div class="row">
                    <div class="col-sm-6 col-md-6 feature-list mb-1" v-for="(feature, index) in features" v-if="index <= 11 && !showAll">
                      <transition name="fade">
                        <div class="d-flex align-content-center">
                          <i class="fas fa-square list-icon pt-2"></i>
                          <span class="features"> {{ feature.title }}</span>
                        </div>
                      </transition>
                    </div>
                    <div class="col-sm-6 col-md-6 feature-list mb-1" v-for="(feature, index) in features" v-if="showAll">
                      <transition name="fade">
                        <div class="d-flex align-content-center">
                          <i class="fas fa-square list-icon pt-2"></i>
                          <span class="features"> {{ feature.title }}</span>
                        </div>
                      </transition>
                    </div>
                </div>
            </div>

            <!-- Mobile -->
            <div class="d-block d-md-none">
                <div class="row px-3">
                    <div class="col-12 feature-list mb-1" v-for="(feature, index) in features" v-if="index <= 4 && !showAll">
                        <transition name="fade">
                            <div class="d-flex align-content-center">
                                <i class="fas fa-square list-icon align-self-center"></i>
                                <span>{{ feature.title }}</span>
                            </div>
                        </transition>
                    </div>
                    <div class="col-12 feature-list mb-1" v-for="(feature, index) in features" v-if="showAll">
                      <transition name="fade">
                        <div class="d-flex align-content-center">
                          <i class="fas fa-square list-icon align-self-center"></i>
                          <span>{{ feature.title }}</span>
                        </div>
                      </transition>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-center d-none d-md-block">
            <button class="show-more-button" @click="showAll = !showAll" v-if="features.length > 9">
                <i :class="buttonIcon"></i>
                <strong><i>{{ buttonText }}</i></strong>
            </button>
        </div>

        <div class="d-block d-md-none">
            <button class="show-more-button btn-block" @click="showAll = !showAll" v-if="features.length > featuresBeforeFadeoutMobile">
                <i :class="buttonIcon"></i>
                <strong><i>{{ buttonText }}</i></strong>
            </button>
        </div>
    </section>
</template>

<script>
    export default {
        name: "AllFeatures",
        props: {
            features: {
                type: Array,
                required: false,
                default: []
            }
        },
        data() {
            return {
                showAll: false,
                featuresBeforeFadeoutMobile: 5,
                featuresBeforeFadeoutDesktop: 10,
            }
        },
        computed: {
            buttonIcon() {
                return this.showAll ? "fal fa-chevron-circle-up" : "fal fa-chevron-circle-down";
            },
            buttonText() {
                return this.showAll ? "verbergen" : "alles anzeigen";
            },
            allFeatures() {
                return this.features;
            },
            firstFeatures() {
                if (this.features.length > 9) {
                    return this.features.splice(9);
                }
                return this.allFeatures;
            }
        },
    }
</script>

<style scoped lang="scss">
    .feature-list {
    }
    @media screen and (min-width: 768px) {
        .fader {
            height: 40px;
        }
    }

    @media screen and (max-width: 767px){
        .fader {
            height: 50px;
        }
    }
    .fader {
        position: absolute;
        z-index: 1;
        width: 100%;
        bottom: 0;
        background: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.5074404761904762) 50%, rgba(255, 255, 255, 0) 100%);
    }

    .list-icon {
        font-size: 0.25rem;
        margin-right: 10px;
    }

    .heading-box {
        .heading {
            margin-bottom: 0;
        }
    }


    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }
 .features {
     max-width: 100%;
     hyphens: auto;
     -webkit-hyphens: auto;
     -webkit-hyphenate-limit-chars: auto 3;
     -webkit-hyphenate-limit-lines: 4;
     -ms-hyphens: auto;
     -ms-hyphenate-limit-chars: auto 3;
     -ms-hyphenate-limit-lines: 4;
 }
</style>
